<template>
    <v-footer app color="white" elevation="5" height="75">
        <v-row>
            <v-btn v-if="(e1 !== 1)" outlined color="primary" @click="backStep" class="ma-5 pa-5">
                <v-icon>mdi-chevron-left</v-icon>
                anterior
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="e1 !== ult" color="primary" outlined @click="siguiente" :disabled="!isValid" class="ma-5 pa-5">
                <v-icon>mdi-chevron-right</v-icon>
                siguiente
            </v-btn>
            <v-btn v-else color="primary" @click="crearAfiliacion" :loading="load" class="ma-5 pa-5 elevation-0">
                <v-icon class="mr-2">mdi-send</v-icon>
                Enviar formulario
            </v-btn>
        </v-row>
    </v-footer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    data() {
        return {
            ult: 5,
            load: false,
        }
    },
    methods: {
        ...mapActions('stepper', ['nextStep', 'backStep', 'pasoValido', 'disableNextButton']),
        ...mapActions('preafiliacion', ['crearFormData']),
        ...mapActions('notificaciones', ['showSnack', 'hideSnack']),

        handleValidation(data) {
            //si los elementos del array son true
            if (data.every((index) => index == true)) {
                this.pasoValido(true)
            }
        },
        crearAfiliacion() {
            this.load = true
            this.crearFormData().then(() => { })
                .catch(() => {
                    this.load = false
                }).finally(() => {
                    this.load = false
                })
            console.log('creando nueva afiliación')
        },
        siguiente() {
            this.disableNextButton()
            this.nextStep()
        },

    },
    computed: {
        ...mapGetters('preafiliacion', ['nuevoAfiliado']),
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('stepper', ['e1', 'isValid']),
    },
}

</script>